import type { PromptDataProfileCopyDto } from "../../types/PromptDataProfileCopyDto";
import type { PromptDataProfileCopyEntity } from "../../types/PromptDataProfileCopyEntity";

export const PromptDataProfileCopyEntityToCopyDto = ({ ...rest }: Readonly<PromptDataProfileCopyEntity>): PromptDataProfileCopyDto => {
    return { ...rest };
};
